import clsx from "clsx";

import {
  CC_ALERT_DANGER_BORDER,
  CC_ALERT_DANGER_TITLE,
  CC_ALERT_WARNING_BORDER,
  CC_ALERT_WARNING_TITLE,
  CC_PANEL,
} from "@/components/case-checking/caseCheckingChrome";

export function CoverageGapBanner({
  tone,
  title,
  gaps,
}: {
  tone: "danger" | "warning";
  title: string;
  gaps: { rule_id: string; label: string }[];
}) {
  const styles =
    tone === "danger"
      ? clsx(CC_ALERT_DANGER_BORDER, CC_ALERT_DANGER_TITLE)
      : clsx(CC_ALERT_WARNING_BORDER, CC_ALERT_WARNING_TITLE);
  return (
    <div className={clsx(CC_PANEL, styles)} data-testid={`remedial-coverage-gap-${tone}`}>
      <p className="text-sm font-medium">{title}</p>
      <p className="mt-1 text-xs text-slate-600 dark:text-slate-400">
        The reviewer bundled or skipped these rules. Check the assessment or add an action.
      </p>
      <ul className="mt-2 space-y-1">
        {gaps.map((g) => (
          <li key={g.rule_id} className="text-xs text-slate-600 dark:text-slate-300">
            <span className="font-mono text-slate-500">{g.rule_id}</span> — {g.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
